<script >
import { ref, onMounted, inject } from 'vue-demi';
import { REPORT_NAME } from '../../common/constant';
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
const __sfc_main = {
  name: 'quote-activity-children-render',
  components: {
    FlowContainer: ComplexComp.Container.Flow
  }
};
__sfc_main.props = ['tpl'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 弹窗显隐
  const visible = inject('visible');
  const modalStatus = inject('modalStatus');
  const {
    ftReport
  } = window.FEGORender?.plugins;
  const close = $event => {
    // 弹窗关闭上报
    ftReport.record($event, {
      $element_name: REPORT_NAME.MODAL_CLOSE_TYPE[modalStatus.value]
    });
    visible.value = false;
  };
  const quoteActivityModalRef = ref();
  onMounted(() => {
    // 弹窗曝光上报
    ftReport.record({
      target: quoteActivityModalRef.value
    }, {
      $element_name: REPORT_NAME.MODAL_VIEW_TYPE[modalStatus.value]
    });
  });

  // 将弹窗传送到body下
  const {
    useTeleport
  } = require('@fegobull/webapi').use;
  useTeleport(document.body);

  // 样式作用到弹窗内容上
  const {
    rem: {
      parseStyle
    }
  } = window.FEGOUtils;
  const contentStyle = parseStyle(props.tpl.style);
  return {
    visible,
    close,
    quoteActivityModalRef,
    contentStyle
  };
};
export default __sfc_main;
</script>

<template>
    <transition name="fade">
        <div v-if="visible" ref="quoteActivityModalRef" class="quote-activity-modal">
            <div class="act-modal-main">
                <div class="act-modal-mask"></div>
                <div class="act-dialog-content">
                    <flow-container :children="tpl.children" :style="contentStyle"></flow-container>
                    <a
                        href="javascript:void(0);"
                        class="close-icon"
                        title="close"
                        @click="close($event)"
                    ></a>
                </div>
            </div>
        </div>
    </transition>
</template>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.quote-activity-modal {
    width: 0 !important;
    height: 0 !important;
    position: relative;
}

.act-modal-main {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.act-modal-mask {
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.act-dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2000;
}

.close-icon {
    display: block;
    width: 0.48rem;
    height: 0.48rem;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjMuMjUiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMTUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0zMCAxOEwxOCAzMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTggMThMMzAgMzAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 50%;
    margin-top: 0.72rem;
}
</style>
